import KJUR from 'jsrsasign'
import {isDev} from './common'

export const getDevJWT = (caseUID, patientUID) => {
  const payload = {
    providerUID: isDev ? 'msk_test' : 'msk',
    role: 'PATIENT',
    ...(caseUID ? { caseUID } : {}),
    ...(patientUID ? { patientUID } : {}),
    processingPayload: {
      userContext: {},
      caseContext: {},
      patientContext: {},
    },
  }

  const sHeader = JSON.stringify({
    alg: 'HS256',
    typ: 'JWT',
  })

  return KJUR.jws.JWS.sign('HS256', sHeader, JSON.stringify(payload), 'secret')
}
